function required(value,label,max=160){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function assertRuntime(runtime){
  const requiredStores=['sessions','items','preparations','stages','targets','woods'];
  for(const name of requiredStores){
    if(!runtime?.[name])throw new TypeError('Journal runtime '+name+' store is required');
  }
}

async function ensureSession(runtime,draft){
  const requestId=required(draft.session.recipeUseRequestId,'recipeUseRequestId',128);
  const existing=(await runtime.sessions.list({includeDeleted:true}))
    .find(session=>session.recipeUseRequestId===requestId);
  if(existing)return existing;
  return runtime.sessions.createDraft(draft.session);
}

export async function persistRecipeUseDraft(runtime,draft){
  assertRuntime(runtime);
  if(!draft?.session?.id)throw new TypeError('Recipe Journal draft is required');

  const session=await ensureSession(runtime,draft);
  const sessionId=session.id;

  for(const item of draft.items||[]){
    if(!await runtime.items.get(item.id)){
      await runtime.items.create(sessionId,item,{sessionStatus:'draft'});
    }
  }

  for(const preparation of draft.preparations||[]){
    if(!await runtime.preparations.get(preparation.itemId)){
      await runtime.preparations.save(preparation.itemId,preparation,{sessionStatus:'draft'});
    }
  }

  for(const wood of draft.woods||[]){
    if(!await runtime.woods.get(wood.id)){
      await runtime.woods.create(sessionId,wood,{sessionStatus:'draft'});
    }
  }

  for(const stage of draft.stages||[]){
    if(!await runtime.stages.get(stage.id)){
      await runtime.stages.create(sessionId,stage,{sessionStatus:'draft'});
    }
  }

  for(const target of draft.stageTargets||[]){
    if(!await runtime.targets.getStageTarget(target.stageId)){
      await runtime.targets.saveStageTarget(target.stageId,target,{sessionStatus:'draft'});
    }
  }

  for(const target of draft.stageItemTargets||[]){
    if(!await runtime.targets.getItemTarget(target.stageId,target.itemId)){
      await runtime.targets.saveItemTarget(
        target.stageId,
        target.itemId,
        target,
        {sessionStatus:'draft'}
      );
    }
  }

  return runtime.sessionBundle?.(sessionId)||session;
}
